import styled from "@emotion/styled";
import PublishIcon from "@material-ui/icons/Publish";
import { BASE_COLORS, FONT_SIZES } from "../../emotion-theme";

export const FileUploadWidget = styled.div`
  font-size: ${FONT_SIZES.large};
  border: solid 1px ${BASE_COLORS.lightGrey};
  padding: 12px;
  text-align: center;
`;
export const FileUploadIcon = styled(PublishIcon)`
  font-size: 56px;
`;
export const FileUploadCaption = styled.div`
  font-size: ${FONT_SIZES.button};
  text-align: center;
`;
export const FileDropzone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 750px;
  color: ${BASE_COLORS.grey};
`;
